import { render, staticRenderFns } from "./RegsiterFormCollection.vue?vue&type=template&id=4414215f&scoped=true"
import script from "./RegsiterFormCollection.vue?vue&type=script&lang=js"
export * from "./RegsiterFormCollection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4414215f",
  null
  
)

export default component.exports